module.exports = __webpack_public_path__ + "img/frame-morning.8142ff09.png";